import { render } from "./ListTypeComponent.vue?vue&type=template&id=52c4b668"
import script from "./ListTypeComponent.vue?vue&type=script&lang=js"
export * from "./ListTypeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__